import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { concat, Observable } from 'rxjs';
import { AuthServiceResolver } from './auth-service-resolver.service';
import { SentResolverService } from './sent-resolver.service';

@Injectable({
  providedIn: 'root'
})
export class AuthSentServiceResolver implements Resolve<Observable<any>> {

  constructor(
    protected authResolver: AuthServiceResolver,
    protected sentResolver: SentResolverService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return concat(this.authResolver.resolve(route, state),
      this.sentResolver.resolve(route, state));
  }
}
